/* Villionaire Theme - Global JavaScript - DEBUG VERSION */

console.log('🔍 Global.js loaded');

// Debounce utility
function debounce(fn, wait) {
  let timer;
  return (...args) => {
    clearTimeout(timer);
    timer = setTimeout(() => fn.apply(this, args), wait);
  };
}

// Update cart count in header
async function updateCartCount() {
  console.log('🔄 updateCartCount called');
  try {
    const response = await fetch('/cart.js');
    const cart = await response.json();
    console.log('✅ Cart data:', cart);
    console.log('📦 Item count:', cart.item_count);
    
    const cartCountElements = document.querySelectorAll('[data-cart-count]');
    console.log('🎯 Found elements:', cartCountElements.length);
    
    cartCountElements.forEach(el => {
      console.log('📝 Updating element:', el);
      console.log('📝 Old value:', el.textContent);
      el.textContent = cart.item_count;
      console.log('📝 New value:', el.textContent);
      el.style.display = cart.item_count > 0 ? 'flex' : 'none';
      console.log('👁️ Display:', el.style.display);
    });
  } catch (error) {
    console.error('❌ Error updating cart count:', error);
  }
}

// Add to cart via AJAX
async function addToCart(formData) {
  console.log('🛒 addToCart called');
  try {
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      body: formData
    });
    
    console.log('📥 Response status:', response.status);
    
    if (!response.ok) throw new Error('Add to cart failed');
    
    const data = await response.json();
    console.log('✅ Item added:', data);
    
    // Update cart count immediately
    console.log('⏰ Calling updateCartCount...');
    updateCartCount();
    
    return data;
  } catch (error) {
    console.error('❌ Error adding to cart:', error);
    throw error;
  }
}

// Format money
function formatMoney(cents, format) {
  if (typeof cents === 'string') {
    cents = cents.replace('.', '');
  }
  const value = (cents / 100).toFixed(2);
  return '₹' + value;
}

// Image lazy loading fallback
if ('loading' in HTMLImageElement.prototype) {
  // Native lazy loading supported
} else {
  // Fallback for older browsers
  document.querySelectorAll('img[loading="lazy"]').forEach(img => {
    img.src = img.dataset.src;
  });
}

// Smooth scroll for anchor links
document.querySelectorAll('a[href^="#"]').forEach(anchor => {
  anchor.addEventListener('click', function(e) {
    e.preventDefault();
    const target = document.querySelector(this.getAttribute('href'));
    if (target) {
      target.scrollIntoView({ behavior: 'smooth' });
    }
  });
});

// Handle Add to Cart form submissions
document.addEventListener('submit', function(e) {
  console.log('📋 Form submitted:', e.target);
  console.log('📋 Form action:', e.target.action);
  
  const form = e.target;
  
  // Check if this is a cart add form
  if (form.action && form.action.includes('/cart/add')) {
    console.log('🛒 CART FORM DETECTED!');
    e.preventDefault();
    
    const formData = new FormData(form);
    const submitButton = form.querySelector('[type="submit"]');
    
    console.log('🔒 Disabling button...');
    
    // Disable button during submission
    if (submitButton) {
      submitButton.disabled = true;
      const originalText = submitButton.textContent;
      submitButton.textContent = 'Adding...';
      console.log('Button text changed to: Adding...');
      
      // Add to cart
      addToCart(formData)
        .then(() => {
          console.log('✅ Success! Re-enabling button...');
          // Re-enable button
          submitButton.disabled = false;
          submitButton.textContent = originalText;
        })
        .catch(() => {
          console.log('❌ Error! Re-enabling button...');
          // Re-enable button on error
          submitButton.disabled = false;
          submitButton.textContent = originalText;
        });
    }
  } else {
    console.log('ℹ️ Not a cart form');
  }
});

// Initialize on DOM ready
document.addEventListener('DOMContentLoaded', () => {
  console.log('✅ DOMContentLoaded fired');
  // Update cart count on page load
  updateCartCount();
});

// Check after 2 seconds
setTimeout(() => {
  console.log('🔍 2-SECOND CHECK:');
  const element = document.querySelector('[data-cart-count]');
  console.log('Cart element exists?', !!element);
  if (element) {
    console.log('Current text:', element.textContent);
  }
  
  const forms = document.querySelectorAll('form');
  console.log('Total forms:', forms.length);
  forms.forEach((form, i) => {
    console.log(`Form ${i}:`, form.action);
  });
}, 2000);